import { TextField } from "office-ui-fabric-react";
import * as React from "react";
import Partner from "../../../classes/Partner";
import { ContentType, HttpVerb, requestWithAuth } from "../../../utils/httpRequest";
import { _t } from "../../../utils/Translator";
import api from "../../api";
import AppContext from "../AppContext";
import "./LogCommentInput.css";

type LogCommentProps = {
  partner: Partner;
  model: string;
  resId: number;
  updateLoggedState: (boolean) => void;
};

type LogCommentState = {
  query: string;
  isLoading: boolean;
};

class LogCommentInput extends React.Component<LogCommentProps, LogCommentState> {
  constructor(props, context) {
    super(props, context);
    this.state = { query: "", isLoading: false };
  }

  private onQueryChanged = event => {
    const query = event.target.value;
    this.setState({ query: query });
  };

  private logComment = async event => {
    if (event.key !== "Enter") return;
    this.setState({ isLoading: true });
    this.props.updateLoggedState(1);

    const createProjectRequest = requestWithAuth(
      HttpVerb.PATCH,
      api.baseURL + api.logSingleMail,
      ContentType.Json,
      {
        args: [
          {
            model: this.props.model,
            res_id: this.props.resId,
            body: this.state.query,
            message_type: "comment"
          }
        ]
      }
    );

    let response = null;
    try {
      const { responseText } = await createProjectRequest.promise;
      response = JSON.parse(responseText);
      this.props.updateLoggedState(3);
    } catch (error) {
      if (error) {
        this.context.showHttpErrorMessage(error);
        this.setState({ isLoading: false });
      }
      this.props.updateLoggedState(0);
      return;
    }

    console.log(response);
  };

  render() {
    return (
      <div className="project-result-container" onClick={e => e.stopPropagation()}>
        <div>{_t("Write a comment")}</div>
        <div className="project-search-bar">
          <TextField
            className="input-search"
            placeholder={_t("Add comment...")}
            value={this.state.query}
            autoComplete="off"
            onChange={this.onQueryChanged}
            onFocus={e => e.target.select()}
            onKeyDown={e => {
              this.logComment(e);
            }}
          />
        </div>
      </div>
    );
  }
}

LogCommentInput.contextType = AppContext;
export default LogCommentInput;
